/// <amd-module name="Dashboards/WidgetContractServices/WideConfigPanelPolicy" />
export function widgetConfigUsesWideFormat(contributionId: string): boolean {
    const WidgetsWithWideWidth = [
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.BurndownWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.BurnupWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.LeadTimeWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.CycleTimeWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.AnalyticsTrendsWidget",
        "ms.vss-dashboards-web.Microsoft.VisualStudioOnline.Dashboards.MonteCarloWidget",
        "ms.vss-test-web.Microsoft.VisualStudioTeamServices.TestManagement.AnalyticsTestTrendWidget"
    ];

    return WidgetsWithWideWidth.some(item => item === contributionId);
}
